
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scholarship/UNSAT",
      function () {
        return require("private-next-pages/scholarship/UNSAT.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scholarship/UNSAT"])
      });
    }
  